<template>
  <div class="not-page">
    <header class="not-cabecera">
      <div>
        <h1 class="not-titulo">Notificaciones</h1>
        <p class="not-subtitulo">
          Avisos que se muestran como banner descartable a los usuarios del portal cliente
          al ingresar a Facturación, entre la fecha/hora de inicio y la de fin indicadas.
        </p>
      </div>
      <button class="not-boton not-boton--primario" @click="abrirNueva">
        <i class="bi bi-plus-lg"></i> Nueva notificación
      </button>
    </header>

    <div v-if="cargando" class="not-info">Cargando...</div>
    <div v-else-if="!notificaciones.length" class="not-info">No hay notificaciones registradas.</div>

    <article v-for="n in notificaciones" :key="n.id" class="not-card">
      <div class="not-card__header">
        <div class="not-card__meta">
          <span class="not-badge" :class="claseTipo(n.tipo).clase">{{ claseTipo(n.tipo).texto }}</span>
          <span class="not-badge" :class="claseVigencia(n).clase">{{ claseVigencia(n).texto }}</span>
          <span v-if="!Number(n.activo)" class="not-badge not-badge--neutro">desactivada</span>
          <span class="not-rango"><i class="bi bi-calendar-range"></i> {{ formatoLegible(n.fecha_desde) }} → {{ formatoLegible(n.fecha_hasta) }}</span>
        </div>
        <div class="not-card__acciones">
          <button class="not-boton not-boton--xs not-boton--secundario" @click="editar(n)" title="Editar"><i class="bi bi-pencil"></i></button>
          <button class="not-boton not-boton--xs not-boton--peligro" @click="eliminar(n)" title="Eliminar"><i class="bi bi-trash"></i></button>
        </div>
      </div>
      <p class="not-card__mensaje">{{ n.mensaje }}</p>
    </article>

    <!-- Modal crear/editar -->
    <div v-if="modal" class="not-modal-fondo" @click.self="modal = null">
      <div class="not-modal">
        <h2>{{ modal.id ? 'Editar notificación' : 'Nueva notificación' }}</h2>
        <label>Mensaje
          <textarea v-model="modal.mensaje" class="not-input" rows="3" placeholder="Texto que verán los usuarios en Facturación"></textarea>
        </label>
        <label>Tipo
          <select v-model="modal.tipo" class="not-input">
            <option value="info">Informativo</option>
            <option value="advertencia">Advertencia</option>
            <option value="urgente">Urgente</option>
          </select>
        </label>
        <div class="not-grid-2">
          <label>Desde<input v-model="modal.fecha_desde" type="datetime-local" class="not-input"/></label>
          <label>Hasta<input v-model="modal.fecha_hasta" type="datetime-local" class="not-input"/></label>
        </div>
        <label class="not-check"><input v-model="modal.activo" type="checkbox"/> Activa</label>
        <div class="not-modal__acciones">
          <button class="not-boton not-boton--secundario" @click="modal = null">Cancelar</button>
          <button class="not-boton not-boton--primario" @click="guardar" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Confirmacion -->
    <div v-if="confirmacion" class="not-modal-fondo" @click.self="confirmacion = null">
      <div class="not-modal not-modal--confirm">
        <h2>{{ confirmacion.titulo }}</h2>
        <p>{{ confirmacion.mensaje }}</p>
        <div class="not-modal__acciones">
          <button class="not-boton not-boton--secundario" @click="confirmacion = null">Cancelar</button>
          <button class="not-boton not-boton--peligro" @click="ejecutarConfirmacion">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import notificacionesService from '@/services/notificacionesService'
import { notifySuccess, notifyError } from '@/services/notificationService'

export default {
  name: 'AdminNotificaciones',
  data() {
    return {
      cargando: false,
      guardando: false,
      notificaciones: [],
      modal: null,
      confirmacion: null,
    }
  },
  mounted() { this.cargar() },
  methods: {
    async cargar() {
      this.cargando = true
      try {
        const res = await notificacionesService.listar()
        this.notificaciones = res.data || []
      } catch (e) {
        notifyError('No se pudieron cargar las notificaciones.')
      } finally { this.cargando = false }
    },
    abrirNueva() {
      const ahora = new Date()
      const enUnaHora = new Date(ahora.getTime() + 60 * 60 * 1000)
      this.modal = {
        mensaje: '', tipo: 'info',
        fecha_desde: this.aInputLocal(ahora),
        fecha_hasta: this.aInputLocal(enUnaHora),
        activo: true,
      }
    },
    editar(n) {
      this.modal = {
        ...n,
        activo: !!Number(n.activo),
        fecha_desde: this.aInputLocal(n.fecha_desde),
        fecha_hasta: this.aInputLocal(n.fecha_hasta),
      }
    },
    async guardar() {
      const n = this.modal
      if (!n.mensaje?.trim()) { notifyError('El mensaje es obligatorio.'); return }
      if (!n.fecha_desde || !n.fecha_hasta) { notifyError('Las fechas desde/hasta son obligatorias.'); return }
      if (n.fecha_hasta < n.fecha_desde) { notifyError('La fecha hasta no puede ser anterior a la fecha desde.'); return }

      const payload = {
        ...n,
        fecha_desde: this.aMysql(n.fecha_desde),
        fecha_hasta: this.aMysql(n.fecha_hasta),
      }

      this.guardando = true
      try {
        if (n.id) await notificacionesService.actualizar(n.id, payload)
        else      await notificacionesService.crear(payload)
        notifySuccess('Notificación guardada.')
        this.modal = null
        await this.cargar()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al guardar la notificación.')
      } finally { this.guardando = false }
    },
    eliminar(n) {
      this.confirmacion = {
        titulo: 'Eliminar notificación',
        mensaje: 'Se eliminará este aviso y dejará de mostrarse en Facturación de inmediato.',
        accion: async () => {
          try {
            await notificacionesService.eliminar(n.id)
            notifySuccess('Notificación eliminada.')
            await this.cargar()
          } catch (e) {
            notifyError(e?.response?.data?.error || 'No se pudo eliminar.')
          }
        },
      }
    },
    async ejecutarConfirmacion() {
      const accion = this.confirmacion?.accion
      this.confirmacion = null
      if (accion) await accion()
    },
    claseVigencia(n) {
      const ahora = new Date()
      const desde = new Date(n.fecha_desde.replace(' ', 'T'))
      const hasta = new Date(n.fecha_hasta.replace(' ', 'T'))
      if (ahora < desde) return { texto: 'programada', clase: 'not-badge--info' }
      if (ahora > hasta) return { texto: 'expirada', clase: 'not-badge--neutro' }
      return { texto: 'vigente', clase: 'not-badge--exito' }
    },
    // Convierte una fecha "YYYY-MM-DD HH:MM:SS" (backend) o un objeto Date
    // al formato que espera <input type="datetime-local"> ("YYYY-MM-DDTHH:MM").
    aInputLocal(fecha) {
      const d = fecha instanceof Date ? fecha : new Date(String(fecha).replace(' ', 'T'))
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    // Convierte el valor de <input type="datetime-local"> ("YYYY-MM-DDTHH:MM")
    // al formato DATETIME de MySQL ("YYYY-MM-DD HH:MM:SS").
    aMysql(valorInputLocal) {
      const conEspacio = valorInputLocal.replace('T', ' ')
      return conEspacio.length === 16 ? conEspacio + ':00' : conEspacio
    },
    formatoLegible(fechaMysql) {
      if (!fechaMysql) return ''
      const d = new Date(fechaMysql.replace(' ', 'T'))
      const pad = (n) => String(n).padStart(2, '0')
      return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    claseTipo(tipo) {
      const mapa = {
        info:        { texto: 'informativo', clase: 'not-badge--info' },
        advertencia: { texto: 'advertencia', clase: 'not-badge--advertencia' },
        urgente:     { texto: 'urgente', clase: 'not-badge--peligro' },
      }
      return mapa[tipo] || mapa.info
    },
  },
}
</script>

<style scoped>
.not-page { color: var(--text-primary); }
.not-cabecera { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 18px; gap: 16px; }
.not-titulo { font-size: 1.4rem; margin: 0; }
.not-subtitulo { margin: 4px 0 0; color: var(--text-secondary); font-size: 0.9rem; max-width: 640px; }

.not-card {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-sm);
}
.not-card__header { display: flex; justify-content: space-between; align-items: center; gap: 12px; flex-wrap: wrap; }
.not-card__meta { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.not-card__acciones { display: flex; gap: 6px; }
.not-card__mensaje { color: var(--text-primary); font-size: 0.92rem; margin: 10px 0 0; white-space: pre-wrap; }

.not-rango { color: var(--text-secondary); font-size: 0.82rem; }

.not-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: lowercase;
}
.not-badge--exito       { background: color-mix(in srgb, var(--accent-success) 18%, transparent); color: var(--accent-success); }
.not-badge--info        { background: color-mix(in srgb, var(--primary-main) 18%, transparent); color: var(--primary-main); }
.not-badge--neutro      { background: var(--bg-main); color: var(--text-muted); }
.not-badge--advertencia { background: color-mix(in srgb, var(--accent-warning) 20%, transparent); color: var(--accent-warning); }
.not-badge--peligro     { background: color-mix(in srgb, var(--accent-danger) 18%, transparent); color: var(--accent-danger); }

.not-info { padding: 14px; color: var(--text-secondary); }

.not-boton {
  border: 1px solid var(--border-main);
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.88rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, border-color 0.15s;
}
.not-boton:hover:not(:disabled) { background: var(--bg-main); }
.not-boton:disabled { opacity: 0.6; cursor: not-allowed; }
.not-boton--xs { padding: 4px 8px; font-size: 0.78rem; }
.not-boton--primario   { background: var(--primary-main); border-color: var(--primary-main); color: #fff; }
.not-boton--primario:hover:not(:disabled) { background: var(--primary-hover); border-color: var(--primary-hover); }
.not-boton--secundario { background: transparent; }
.not-boton--peligro    { color: var(--accent-danger); border-color: color-mix(in srgb, var(--accent-danger) 40%, transparent); }
.not-boton--peligro:hover:not(:disabled) { background: color-mix(in srgb, var(--accent-danger) 12%, transparent); }

.not-modal-fondo { position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; }
.not-modal {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 12px;
  padding: 22px;
  min-width: 420px;
  max-width: 560px;
  border: 1px solid var(--border-main);
  box-shadow: var(--shadow-md);
}
.not-modal h2 { font-size: 1.1rem; margin: 0 0 16px; }
.not-modal label { display: block; margin-bottom: 10px; font-size: 0.85rem; color: var(--text-secondary); }
.not-modal__acciones { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; }
.not-modal--confirm p { color: var(--text-secondary); margin-bottom: 12px; }

.not-input {
  width: 100%;
  background: var(--bg-main);
  color: var(--text-primary);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 0.92rem;
  margin-top: 4px;
  font-family: inherit;
}
.not-input:focus { outline: none; border-color: var(--border-focus); }
.not-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.not-check { display: inline-flex; align-items: center; gap: 8px; }
.not-check input { transform: scale(1.05); }
</style>
